import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setKountSessionId } from '../../slices/payments';

const kountSessionIdFromLocalStorage = localStorage.getItem('kountSessionId');
const KOUNT_SDK_URL = `https://${process.env.KOUNT_DATA_COLLECTOR_URL}/
collect/sdk?m=${process.env.KOUNT_MERCHANT_ID}
${kountSessionIdFromLocalStorage ? `&s=${kountSessionIdFromLocalStorage}` : ''}`;

const KountSdk = () => {
  const kountSessionIdFromState = useSelector((state) =>
    state.payments?.kountSessionId);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadKountSdk = () => {
      const client = new window.ka.ClientSDK();
      client.autoLoadEvents();
      if (!kountSessionIdFromState) {
        localStorage.setItem('kountSessionId', window.ka.sessionId);
        dispatch(setKountSessionId(window.ka.sessionId));
      }
    };

    const kountScript = document.getElementById('kount-sdk-script');
    if (!window.ka && !kountScript) {
      const s = document.createElement('script');
      s.id = 'kount-sdk-script';
      s.type = 'text/javascript';
      s.async = true;
      s.src = KOUNT_SDK_URL;
      s.onload = loadKountSdk;
      document.getElementsByTagName('body')[0].appendChild(s);
    }
  }, [kountSessionIdFromState, dispatch]);

  return <div id="kaxsdk" data-event="load" />;
};

export default KountSdk;
